import PropertyName from './PropertyName';

export default PropertyName;
